const setCookie = (cname, cvalue) => {
    document.cookie = `${cname}=${cvalue}`;
};

const getCookie = (cookieName) => {
    let cookieToUse;

    if (typeof window !== 'undefined' && window.embedderCookie) {
        cookieToUse = window.embedderCookie;
    } else if (typeof document !== 'undefined' && document.cookie) {
        cookieToUse = document.cookie;
    }
    if (cookieToUse) {
        const cookie = {};

        cookieToUse.split(';').forEach((el) => {
            const [k, v] = el.split('=');

            cookie[k.trim()] = v;
        });
        return cookie[cookieName];
    }
    return '';
};

const getServerProperty = (key) => {
    if (typeof window !== 'undefined') {
        const serverData = window.__SERVER_DATA__ || {};

        return serverData[key];
    }
    return undefined;
};

const getDOMValue = (name) => {
    if (typeof document === 'undefined') {
        return undefined;
    }

    if (!document.getElementsByName) {
        return undefined;
    }

    const elements = document.getElementsByName(name);

    if (!elements.length) {
        return undefined;
    }
    const element = elements[0];
    const value = element.value;

    return value;
};

export default {
    setCookie,
    getCookie,
    getServerProperty,
    getDOMValue,
};
